// extracted by mini-css-extract-plugin
module.exports = {"card":"SectionCard_card__1ezng","header":"SectionCard_header__1ZIeV","title":"SectionCard_title__1R-Q3"};